(function () {
  'use strict';

  var CSS = [
    '.cs-filter-search{display:flex;align-items:center;gap:6px;padding:8px 10px;margin:10px 0;',
    'border:1px solid rgba(var(--color-foreground),.15);border-radius:var(--inputs-radius,4px);',
    'background:rgba(var(--color-foreground),.04);}',
    '.cs-filter-search svg{flex-shrink:0;opacity:.4;}',
    '.cs-filter-search__input{flex:1;min-width:0;border:none;background:transparent;outline:none;',
    'font-size:1.2rem;font-family:inherit;color:rgba(var(--color-foreground),1);line-height:1.5;}',
    '.cs-filter-search__input::placeholder{color:rgba(var(--color-foreground),.38);}',
    '.cs-filter-scroll{max-height:300px;overflow-y:auto;margin-bottom:2rem;padding-top:6px;',
    'scrollbar-width:thin;scrollbar-color:#62679b transparent;}',
    '.cs-filter-scroll::-webkit-scrollbar{width:3px;}',
    '.cs-filter-scroll::-webkit-scrollbar-thumb{background:#62679b;border-radius:3px;}',
    '.cs-filter-scroll .fieldset-block__content{padding-top:0 !important;margin-top:0 !important;}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('cs-filter-search-styles')) return;
    var s = document.createElement('style');
    s.id = 'cs-filter-search-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function enhance(contentDiv) {
    if (contentDiv.dataset.csEnhanced) return;
    contentDiv.dataset.csEnhanced = '1';

    var itemCount = contentDiv.querySelectorAll('xo-filters-field').length;
    var scroll = document.createElement('div');
    scroll.className = 'cs-filter-scroll';
    contentDiv.parentNode.insertBefore(scroll, contentDiv);
    scroll.appendChild(contentDiv);

    if (itemCount < 5) return;

    var header = scroll.previousElementSibling;
    var title = header ? (header.querySelector('.fieldset-block__title') || {}).textContent || '' : '';

    var bar = document.createElement('div');
    bar.className = 'cs-filter-search';
    bar.innerHTML =
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
        '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>' +
      '</svg>' +
      '<input type="text" class="cs-filter-search__input" placeholder="Search ' + title.trim().toLowerCase() + '…" aria-label="Search ' + title.trim() + '" autocomplete="off">';

    scroll.parentNode.insertBefore(bar, scroll);
  }

  /* Event delegation — one listener on document catches ALL search inputs */
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.classList.contains('cs-filter-search__input')) return;
    var bar = e.target.parentElement;
    var scrollWrap = bar ? bar.nextElementSibling : null;
    if (!scrollWrap || !scrollWrap.classList.contains('cs-filter-scroll')) return;
    var q = e.target.value.toLowerCase().trim();
    scrollWrap.querySelectorAll('xo-filters-field').forEach(function (el) {
      el.style.display = (!q || el.textContent.toLowerCase().indexOf(q) > -1) ? '' : 'none';
    });
  });

  function run() {
    injectStyles();
    document.querySelectorAll('.fieldset-block__content--column').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Re-run after filter/sort AJAX updates */
  var xf = document.querySelector('xo-filters');
  if (xf) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'XO-FILTERS-CONTENT' || (n.querySelector && n.querySelector('xo-filters-content'))) {
            setTimeout(run, 100);
            return;
          }
        }
      }
    }).observe(xf, { childList: true, subtree: true });
  }
})();
